import { StudentsListCombinedProps } from './types';

const usePresenter = (props: StudentsListCombinedProps): StudentsListCombinedProps => {
  return props;
};

export default usePresenter;
